<script lang="ts">
    export let height: string = "0.5rem"
    export let fill: string | undefined

</script>

<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" height={height} fill={fill}>
    <circle cx="50" cy="50" r="50"/>
</svg>